import { render, staticRenderFns } from "./SupplierAgentBase.vue?vue&type=template&id=3cb193ba&"
import script from "./SupplierAgentBase.vue?vue&type=script&lang=js&"
export * from "./SupplierAgentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports